var React = require('react');

function LolIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#CBD2DD","fillRule":"nonzero","d":"M16.831 10.147c0-3.785-2.84-6.922-6.517-7.423V.556c4.881.509 8.686 4.61 8.686 9.59 0 2.6-1.368 4.854-1.368 4.854h-2.604a7.432 7.432 0 0 0 1.803-4.853zm-14.117 6.52A9.483 9.483 0 0 1 0 10a9.49 9.49 0 0 1 2.714-6.667v3.63A7.435 7.435 0 0 0 2.064 10c0 1.082.236 2.11.65 3.037v3.63zm0 3.333l1.637-2.017V2.025L2.714 0h5.94v16.74h9.803l-2.19 3.256L2.713 20z"}));
}

LolIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 19 20"};

module.exports = LolIcon;

LolIcon.default = LolIcon;
